import axiosInstance from "../config/axios.config";

export const getOpFacilityServicesApi = (facilityId, query = {}) => {
  return axiosInstance.get(`/careservices/facility-services/`, {
    params: { facility_id: facilityId, ...query },
  });
};

export const getOpServicesListApi = (admissionId, query = {}) => {
  return axiosInstance.get(`/outpatient/patient-services/`, {
    params: { admission_id: admissionId, ...query }, 
  });
};


export const assignOpServicesApi = (payload) =>
  axiosInstance.post(`/outpatient/patient-services/`, payload);

export const updateOpServicesApi = (payload) =>
  axiosInstance.patch(`/outpatient/services/bulk-action/`, payload);

export const deleteOpServicesApi = (payload) =>
  axiosInstance.delete(`/outpatient/services/bulk-action/`, { data: payload });
